module.exports = __webpack_public_path__ + "static/media/Group255.9a0675b7.svg";